import AIAgentDemoSection from '../components/AIAgentDemoSection'

const Demo = () => {
  return <AIAgentDemoSection />
}

export default Demo
